<template>
    <main class="wrapper flex flex-col text-sm">
        <header class="title relative text-center text-lg">
            <IconBack v-show="showBack" class="absolute" @click="$emit('on-back')" />
            {{ title }}
            <slot name="header" />
        </header>
        <section class="content flex-auto">
            <slot name="content" />
        </section>
        <footer class="footer text-center">
            <slot name="footer" />
        </footer>
    </main>
</template>

<script>
import IconBack from '@/assets/svg/icon_back.svg';

export default {
    name: 'RevokeWrapper',
    components: {
        IconBack,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        showBack: {
            type: Boolean,
            default: true,
        },
        onBack: {
            type: Function,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    height: 100vh;
    padding: var(--g-space-md) 18px var(--g-space-xl) var(--g-space-lg);
    color: var(--g-gray-2);
    background-color: rgba(0, 0, 0, 0.8);

    .title {
        margin-bottom: var(--g-space-md);

        svg {
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
    }

    .content {
        overflow-y: auto;
        padding-right: 6px;
    }

    .footer {
        margin-top: var(--g-space-sm);
    }
}
</style>
